import React, { Fragment, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Grid, IconButton, Typography } from '@mui/material';
import { Fields } from '../../Fields';
import { FIELD_TYPES, showDateTimeFromString } from '../../../utils/utils';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
//import { JourneyClasses } from '../../../styles/JourneyClasses';
import { CyanButton } from '../../CyanButton';
//import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export default function OtherFiles(props) {
    const isLoading = props.isLoading || false
    const journeyData = props.journeyData || {} 

    const otherFiles = journeyData.otherFiles || []

    const defDialogData = {open:false}

    const [dialogData, setDialogData] = useState(defDialogData);

    const handleSave = e => {
        e.preventDefault();

        let paramsToPass = {goToNextStep:false}

        const title = dialogData.title
        const link = dialogData.link

        if (dialogData.id !== undefined){
            paramsToPass.otherFiles = otherFiles.map((otherFile, index) => (index === dialogData.id)?{...otherFile, title, link, isDeleted:dialogData.isDelete}:otherFile)
        } else {
            paramsToPass.otherFiles = [...otherFiles, {title, link}]
        }

        props.handleSaveData(paramsToPass,(response)=>{
            setDialogData(defDialogData)
        }, (error) => {
            setDialogData({...dialogData,error})
        })
    }

    const getValue = (name, defaultValue) => {
        if (dialogData[name] !== undefined){
            return dialogData[name]
        } else {
            return defaultValue
        }
    }

    const handleChangeField = e => {
        setDialogData({...dialogData,[e.target.name]: e.target.value})
    };

    const handleCancel = () => {
        setDialogData(defDialogData)
    }

    const handleAddLink = () => {
        setDialogData({open:true})
    }

    const handleEditLink = (id, object) => () => {
        setDialogData({open:true, id, ...object})
    }

    const handleDeleteLink = (id, object) => () => {
        setDialogData({open:true, id, isDelete:true, ...object})
    }

    const fields = [
        {name:'title', label:'Title', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required:true},
        {name:'link', label:'Link', defaultValue: '', type:FIELD_TYPES.TEXT, placeholder:'Example: https://docs.google.com/document/d/{id}/edit?usp=sharing&ouid={uid}&rtpof=true&sd=true', sm:12, required:true},
    ]

    //const journeyClasses = JourneyClasses();

    return (
        <>
            <Dialog onClose={handleCancel} open={dialogData.open}>
                <form onSubmit={handleSave}>
                    {(dialogData.error)&&<Typography color="error">{dialogData.error}</Typography>}
                    <DialogContent dividers>
                        {dialogData.isDelete?
                        <Typography>Delete File?</Typography>:  
                        <Fields fields={fields} getValue={getValue} handleChange={handleChangeField}/>}
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={isLoading} onClick={handleCancel} color="primary" size="small" aria-label="Cancel">
                            {dialogData.isDelete?'No':'Cancel'}
                        </Button>
                        <Button
                            disabled={isLoading}
                            type="submit"
                            variant="outlined"
                            color="primary"
                            size="small"
                            aria-label='Save'
                        >
                            {dialogData.isDelete?'Yes':'Save'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, marginTop: 8}}>
                <Typography variant='h3' style={{fontSize: 18,lineHeight: '28px'}}>Additional Files</Typography>
                <CyanButton
                    variant='contained'
                    disabled={isLoading}
                    onClick={handleAddLink}
                    color="primary"
                    style={{textTransform: 'capitalize', minWidth: 200}}
                    startIcon={<AddIcon />}
                >
                    Add Google Docs File
                </CyanButton>
            </div>

            <>
                {/*otherFiles.map((otherFile, index) => <Fragment key={index}>          
                    {!otherFile.isDeleted&&<Grid item sm={4} xs={12}>
                        <div>
                            <a href={otherFile.link} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none'}}>
                                <div className={journeyClasses.blockButton}>
                                    <InsertDriveFileIcon style={{color: '#757575', marginRight: 8}}/>
                                    <Typography variant='h4' style={{fontSize: 16, fontWeight: 500, lineHeight: '28px', color: '#362121'}}>
                                        {otherFile.title}
                                    </Typography>
                                </div>
                            </a>
                            {(isAdmin)&&<IconButton aria-label="edit" onClick={handleEditLink(index, otherFile)} size='small' style={{marginLeft:4}}>
                                <EditIcon fontSize="small" />
                            </IconButton>}
                            {(isAdmin)&&<IconButton aria-label="delete" onClick={handleDeleteLink(index, otherFile)} size='small' style={{marginLeft:4}}>
                                <DeleteIcon/>
                            </IconButton>}
                        </div>
                    </Grid>}
                </Fragment>)*/}
                {otherFiles.map((otherFile, index) => <Fragment key={index}>            
                    {!otherFile.isDeleted&&<div  className="tag" style={{display: 'inline-flex', fontSize: 15, alignItems: 'center', cursor: 'default'}} >
                        <a href={otherFile.link} target="_blank" rel="noopener noreferrer">{otherFile.title}{otherFile.uploadTime?(' - '+showDateTimeFromString(otherFile.uploadTime, true)):''}</a>
                        <IconButton aria-label="edit" onClick={handleEditLink(index, otherFile)} size='small' style={{marginLeft:4}}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton aria-label="delete" onClick={handleDeleteLink(index, otherFile)} size='small' style={{marginLeft:4}}>
                            <DeleteIcon/>
                        </IconButton>
                    </div>}
                </Fragment>)}
            </>

            {/*otherFiles.map((otherFile, index) => <Fragment key={index}>            
                {!otherFile.isDeleted&&<div  className="tag" style={{display: 'inline-flex', fontSize: 15, alignItems: 'center', cursor: 'default'}} >
                    <a href={otherFile.link} target="_blank" rel="noopener noreferrer">{otherFile.title}</a>
                    {(isAdmin)&&<IconButton aria-label="edit" onClick={handleEditLink(index, otherFile)} size='small' style={{marginLeft:4}}>
                        <EditIcon fontSize="small" />
                    </IconButton>}
                    {(isAdmin)&&<IconButton aria-label="delete" onClick={handleDeleteLink(index, otherFile)} size='small' style={{marginLeft:4}}>
                        <DeleteIcon/>
                    </IconButton>}
                </div>}
            </Fragment>)*/}
        </>
    )
}